import { QueryClient } from '@tanstack/react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // suspense: true,
      staleTime: 30_000,
      // Retry 1 lần cho lỗi mạng / 5xx. Interceptor (shared/api/http) đổi lỗi envelope thành { errorCode } không có
      // response, nên đọc errorCode trước; 4xx (gồm 401/403) không retry.
      retry: (failureCount, error) => {
        const e = error as { errorCode?: number; response?: { status?: number } } | undefined
        const status = e?.errorCode ?? e?.response?.status
        return failureCount < 1 && (status === undefined || status >= 500)
      },
    },
    mutations: { retry: false },
  },
})

export default queryClient
